import { ListingAppearanceSection as SharedListingAppearanceSection } from "shared/app/ListingAppearanceSection";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import addressApi from "api/landlord/address";
import { Property } from "types/landlord/address";
import { useEditDetailsPermissions } from "shared/hooks/use-edit-details-permissions";

export const ListingAppearanceSection = ({
  property
}: {
  property: Property;
}) => {
  const { Property: PropertyLabel, properties: propertiesLabel } =
    useUnitsPropertiesDictionary();
  const { propertyEditDeniedTooltip } = useEditDetailsPermissions();

  return (
    <SharedListingAppearanceSection
      customButtonLink={property.custom_button_link}
      bulkApply={{
        scope: "property",
        sourceId: property.id,
        sourceName: property.name,
        actionLabel: `Apply to additional ${propertiesLabel}`
      }}
      showWarning={Boolean(property.custom_button_missing_source)}
      warningText={`This ${PropertyLabel.toLowerCase()} uses a listing template with a custom button, but no custom button link is set, so the button won't appear on its listing page.`}
      inputId="property-custom-button-link"
      saveCustomButtonLink={(value) =>
        addressApi.editProperty({
          propertyId: property.id,
          custom_button_link: value
        })
      }
      successToast="Property updated successfully"
      errorToastPrefix="Failed to update property"
      invalidateQueryKey={["properties", String(property.id)]}
      editDeniedTooltip={propertyEditDeniedTooltip}
      pmsSync={
        property.pms_id
          ? {
              syncWithPms: property.pms_overrides?.custom_button_link !== false,
              pmsValue: property.pms_values?.custom_button_link,
              saveSyncWithPms: (syncWithPms) =>
                addressApi.editProperty({
                  propertyId: property.id,
                  pms_overrides: { custom_button_link: syncWithPms }
                })
            }
          : undefined
      }
    />
  );
};
